import React from 'react';
import classNames from 'classnames';
import { cellTypes } from '../enums';

const LeaderboardCellHoleTitle = ({ sortingHandlerProps, processingState }) => {
    const isActive = processingState.sortingType === cellTypes.HOLE;
    const stateCss = classNames({
        'is-active': isActive,
        'is-top': isActive && processingState.isSortingAscending
    });

    return (
        <div className={`leaderboard__cell leaderboard__cell--title leaderboard__cell--hole ${stateCss}`}>
            <button
                type="button"
                className="leaderboard__cell-content-title"
                onClick={() => sortingHandlerProps(cellTypes.HOLE)}
            >
                <div className="leaderboard__cell-title">hole</div>
                <div className="leaderboard__cell-title-icon-wrapper">
                    <svg className="leaderboard__cell-title-icon icon" width="9" height="6" focusable="false">
                        <use xlinkHref="#icon-triangle"></use>
                    </svg>
                </div>
            </button>

            <div className="leaderboard__cell-title-m">
                hole
            </div>
        </div>
    );
};
export default LeaderboardCellHoleTitle;
